import Cookies from 'js-cookie';

const EXPIRED_MONTHS_QUANTITY = 6;
const MAIN_DOMAIN = 'sofology.co.uk';
const LOCAL_DOMAIN = 'sit.sofology.co.uk';

export class CookieHelper {
    public removeCookie(key: string) {
        Cookies.remove(key, { domain: this.getCurrentDomain() });
        Cookies.remove(key, { domain: MAIN_DOMAIN });
    }

    public setCookie(key: string, value: string | any): void {
        const expires = new Date();
        expires.setMonth(expires.getMonth() + EXPIRED_MONTHS_QUANTITY);
        Cookies.remove(key, { domain: this.getCurrentDomain() });
        Cookies.set(key, value, { domain: this.getCurrentDomain(), expires: expires });
    }

    public getCookie(key: string): string | undefined {
        return Cookies.get(key);
    }

    public getCurrentDomain(): string {
        const hostName = window.location.hostname.toLowerCase();

        if (hostName === LOCAL_DOMAIN) {
            return hostName;
        }

        const hostNameParts = hostName.split('.');

        if (hostName.startsWith('sofology') || hostNameParts.length === 1) {
            return hostName;
        }

        return hostNameParts.splice(1).join('.');
    }
}

export const cookieHelper = new CookieHelper();